import React from "react";
import { Route, Switch } from "react-router-dom";
import { baseUrlRouter } from "./utils/config";

//Pages
import Login from "./components/container/LoginContainer";
import UploaderLayout from "./components/layouts/UploaderLayout";
import NotFound from "./components/views/NotFound";

export default (
	<div>
		<Switch>
			<Route exact path={baseUrlRouter} component={Login} />
			<Route path={baseUrlRouter + "app"} component={UploaderLayout} />
			<Route path="*" component={NotFound} />
		</Switch>
	</div>
);



// WEBPACK FOOTER //
// ./src/router.js